<template>
  <div id="richTextSection" class="main-area">
    <PageTop class="title" title="Ürün Açıklaması" />
    <div class="editor-container">
      <div class="template-button-wrapper">
        <AppButton v-if="props.isHasContent" sm secondary title="Açıklama Şablonu Seç" @click="handleClick()" />
      </div>
      <JoditEditor
        v-model="internalContent"
        :placeholder="hasContent ? '' : 'Ürünün satışını artırmak için ürün özelliklerini madde madde açıklayabilir, avantajlarını vurgulayabilirsiniz.'"
      />
    </div>
    <span v-if="!isDescriptionAreaValid" class="errorText">Açıklama alanı boş olamaz.</span>
    <div class="form-group">
      <div class="checkbox-label">
        <Checkbox
          label="Bu açıklamayı daha sonra tekrar kullanmak için şablon olarak kaydet."
          id="select"
          :checked="isReusablePattern"
          :onClickFn="handleCheckBoxClick"
        />
      </div>

      <div v-if="isReusablePattern" class="input-field">
        <Input
          type="text"
          class="custom-input"
          id="template-name"
          v-model:value="templateName"
          placeholder="Şablon Adı Gir"
          :isError="isError"
        />
        <span v-if="isError" class="errorText">Şablon adı boş bırakılamaz.</span>
      </div>
    </div>
  </div>
</template>

<script setup>
import PageTop from "@/components/Page/PageTop.vue";
import { JoditEditor, Checkbox, AppButton, Input } from "@n11/so-ui-components";
import { computed, ref, watch } from "vue";
import "jodit/build/jodit.min.css";

const emit = defineEmits(['open-modal','update:content','update:isReusablePattern','update:templateName']);

const props = defineProps({
  content: {
    type: String,
    required: false
  },
  isHasContent: {
    type: Boolean,
    default: false
  }
});

const isError = ref(false);
const isReusablePattern = ref(false);
const internalContent = ref(props.content || null);
const templateName = ref("");
const isDescriptionAreaValid = ref(true);
const isReusablePatternValid = ref(false);

const isEmptyContent = (val) => {
  if (!val) return true;
  const trimmed = val.trim();
  return trimmed === "" || trimmed === "<p><br></p>" || trimmed === "<p></p>" || trimmed === "<br>";
};

const hasContent = computed(() => !isEmptyContent(internalContent.value));

watch(() => props.content, (newVal) => {
  internalContent.value = newVal;
});

watch(internalContent, (val) => {
  const isEmpty = val?.trim() === "" || val === "<p><br></p>";
  const finalVal = isEmpty ? null : val;
  isDescriptionAreaValid.value = !isEmpty;

  emit('update:content', finalVal);
});

watch(templateName, (val) => {
  emit("update:templateName", val);
  
  if (val.trim() !== "") {
    isError.value = false;
  }
});

const handleClick = () => {
  emit('open-modal');
}

const handleCheckBoxClick = () => {
  isReusablePattern.value = !isReusablePattern.value;
  emit('update:isReusablePattern', isReusablePattern.value);
}

const getRichText = () => {
  const cleaned = (internalContent.value || "").replace(/<[^>]*>/g, '').trim();
  isDescriptionAreaValid.value = cleaned !== '';
  isReusablePatternValid.value = isReusablePattern.value ? templateName.value.trim() !== "" : true;
  const validTemplate = isDescriptionAreaValid.value && isReusablePatternValid.value;
  isError.value = !isReusablePatternValid.value;

  return {
    data: {
      templateName: validTemplate ? templateName.value : null,
    },
    isValid: validTemplate,
  };
};

defineExpose({
  getRichText
})
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss";
@import "@/assets/styles/utilities.scss";

.main-area {
  width: 100%;
  display: flex;
  padding: 24px;
  border: 1px solid #d3d6df;
  border-radius: 8px;
  height: auto;
  max-height: 468px;
}
.title {
  margin-bottom: 16px;
}
.form-group {
  display: flex;
  align-items: center;
  gap: 24px;
  margin-top: 16px;

  .checkbox-label {
    display: flex;
    align-items: center;
    white-space: nowrap;
  }

  .input-field {
    flex: 0 0 306px;
    display: flex;
    flex-direction: column;
  }
  .custom-input {
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 4px;
  }

  label {
    font-size: 14px;
    color: #333;
  }

  input[type="checkbox"] {
    margin-right: 8px;
  }
}

.editor-container {
  position: relative;
}

.template-button-wrapper {
  position: absolute;
  top: 8px;
  right: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  padding: 6px 8px;

  button {
    white-space: nowrap;
    padding: 7px 16px;
    line-height: 16px;
  }
}

.errorText {
  font-size: 11px;
  color: $colorE50;
  padding: 0 12px;
  margin-top: 4px;
} 

</style>
